// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PdfsScreen from '../components/Pdfs/PdfsScreen';
import { changePdfPreferences, changePdfsOrder, countPdfs, getPdfs } from '../actions/pdfs';
import { getTablePage } from '../helpers/functions';
import _ from 'lodash';
import { parseListOfPdfs } from '../helpers/parseImmutables';

const listPdfs = [
  {name: 'Pdf name', key: 'filename'},
  {name: 'Pdf type', key: 'pdfType'},
  {name: 'Public', key: 'isPublic'},
];

class PdfsHOC extends Component {
  componentDidMount() {
    this.props.getPdfs({
      limit: this.props.rowsPerPage,
      order: listPdfs[this.props.orderBy].key + ' ' + this.props.order.toUpperCase()
    });
    this.props.countPdfs();
  }

  handlePageChange = (iconType) => {
    let newPage = getTablePage(iconType, this.props.page, this.props.total, this.props.rowsPerPage);
    this.props.changePdfPreferences({key: 'page', value: newPage});
  };

  handleRowsPerPage = (rowsPerPage) => {
    rowsPerPage = parseInt(rowsPerPage);
    let newTotalPages = _.ceil(this.props.total / rowsPerPage);
    let currentPage = this.props.page;
    if (parseInt(currentPage) > newTotalPages) {
      currentPage = newTotalPages;
    }

    this.props.changePdfPreferences({key: 'rowsPerPage', value: rowsPerPage});
    this.props.changePdfPreferences({key: 'page', value: currentPage});
  };

  handleRowSelect = (id) => {
    this.props.history.push('/pdfsAdd/')
  };

  onRequestSort = (payload) => {
    this.props.countPdfs();
    this.props.changePdfsOrder(payload);
  };

  getListRows = () => {
    return this.props.pdfs
      .valueSeq().toArray().map(pdf => ({
        id: pdf.get('id'),
        data: [
          pdf.get('filename'),
          pdf.get('pdfType'),
          pdf.get('isPublic') === true ? 'YES' : 'NO',
        ],
        pdf: `PDFS` + pdf.id
      }))
  };

  render() {
    return <PdfsScreen
      {...this.props}
      listRows={this.getListRows()}
      listColumns={listPdfs}
      handlePageChange={this.handlePageChange}
      handleRowsPerPage={this.handleRowsPerPage}
      handleRowSelect={this.handleRowSelect}
      onRequestSort={this.onRequestSort}
    />
  }
}

const mapStateToProps = state => ({
  pdfs: state.pdfs.get('pdfs'),
  fetching: state.pdfs.get('fetching'),
  total: state.pdfs.get('total') ?
    state.pdfs.get('total') : 0,
  page: state.pdfs.get('page'),
  rowsPerPage: state.pdfs.get('rowsPerPage'),
  order: state.pdfs.get('order'),
  orderBy: state.pdfs.get('orderBy'),
});

const mapDispatchToProps = dispatch => ({
  getPdfs: (payload) => {
    dispatch(getPdfs(payload))
  },
  countPdfs: (payload) => {
    dispatch(countPdfs(payload))
  },
  changePdfPreferences: (payload) => {
    dispatch(changePdfPreferences(payload))
  },
  changePdfsOrder: (payload) => {
    dispatch(changePdfsOrder(payload))
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(PdfsHOC);


// WEBPACK FOOTER //
// ./src/containers/PdfsHOC.js